import * as MutationTypes from './mutationTypes';
import { TableQr } from './models';
import * as api from './api';

export const tableQrListRequest = async ({ commit }, pointOfSaleGuid) => {
  const response = await api.tableQrListRequest(pointOfSaleGuid);
  const recommendationList = TableQr.toInstanceList(response.data);
  commit(MutationTypes.TABLE_QR_LIST_SUCCESS, recommendationList);
};

export const deleteTableQr = async ({ commit }, tableQr) => {
  await api.deleteTableQrRequest(tableQr.guid);
  commit(MutationTypes.DELETE_TABLE_QR_SUCCESS, tableQr);
  return tableQr;
};

export const createTableQr = async ({ commit }, tableQr) => {
  const response = await api.createTableQrRequest(tableQr.serialize());
  // Check 409
  const newTableQr = TableQr.toInstance(response.data);
  commit(MutationTypes.CREATE_TABLE_QR_SUCCESS, newTableQr);
  return newTableQr;
};

export const editTableQr = async ({ commit }, tableQr) => {
  const response = await api.editTableQrRequest(tableQr.guid, tableQr.serialize());
  // Check 409
  const editedTableQr = TableQr.toInstance(response.data);
  commit(MutationTypes.EDIT_TABLE_QR_SUCCESS, editedTableQr);
  return editedTableQr;
};
